export const MASTER_PIN = "1234"; // Cámbialo aquí

export function validarPIN(pin) {
  return pin === MASTER_PIN;
}
